<div class="p-4 lg:p-10">
  <div class="consents" *ngIf="country === 'de'">
    <div class="grid gap-4 text-mat-ef-revolution-primary-500">
      <h2 class="font-canelablack text-4xl md:text-5xl">
        {{ 'communication' | sharedTranslate }}
      </h2>
      <div class="subtitle py-6 font-efSans font-bold uppercase">
        {{ 'data-protection' | sharedTranslate }}
      </div>

      <div *ngIf="!newGdprNotice" class="mb-6">
        <p class="my-6">
          {{ 'consent-channels-message' | sharedTranslate }}
        </p>
      </div>
      <div *ngIf="newGdprNotice" class="mb-6">
        <!-- prettier-ignore -->
        <p
          class="my-6"
          [innerHTML]="getTranslation1()"
        ></p>
        <!-- prettier-ignore -->
        <p
          [innerHTML]="getTranslation2()"
        ></p>
      </div>
      <form
        #consentsForm
        [action]="viewData.registrationAction"
        method="POST"
        [formGroup]="form"
      >
        <div class="w-full">
          <div class="grid grid-cols-12">
            <div class="col-span-6">&nbsp;</div>
            <div class="col-span-6 flex justify-around">
              <h3 class="ef-paragraph" *ngFor="let channel of channels">
                {{
                  {
                    str: channel,
                    prefix: 'customerPortal.kc.consents.channels.'
                  } | transifexTranslate
                }}
              </h3>
            </div>
          </div>
          <mat-divider></mat-divider>

          <div class="grid grid-cols-12 py-6 lg:py-12">
            <div class="col-span-6 flex flex-col">
              <span class="group-name ef-headline-7">
                {{ 'emil-frey-digital-services' | sharedTranslate }}
              </span>
              <span class="group-name ef-small-paragraph">
                <T
                  str="Cannstatter Str. 46, 70190 Stuttgart"
                  key="customerPortal.kc.consents.company.street"
                  tags="kc-forms, 3.1"
                ></T>
              </span>
            </div>
            <div class="col-span-6 flex justify-around">
              <mat-checkbox
                color="primary"
                *ngFor="let channel of channels"
                formControlName="{{ channel }}"
              ></mat-checkbox>
            </div>
          </div>

          <mat-divider></mat-divider>
        </div>

        <input type="hidden" name="step" value="gdpr" />
        <input
          *ngFor="let selectedChannel of selectedChannels"
          type="hidden"
          name="setConsents"
          [value]="selectedChannel"
        />
      </form>

      <div class="py-6 flex justify-end">
        <button
          mat-button
          mat-raised-button
          color="secondary"
          class="revolution w-full md:w-1/2"
          (click)="submit()"
          [disabled]="!form.valid || submitting"
        >
          {{ 'next' | sharedTranslate }}
        </button>
      </div>

      <div class="gdpr-text" *ngIf="!newGdprNotice">
        <!-- prettier-ignore -->
        <p
          [innerHTML]="getTranslation3()"
        ></p>
        <!-- prettier-ignore -->
        <p
          [innerHTML]="getTranslation4()"
        ></p>
        <!-- prettier-ignore -->
        <p
          class="consents-paragraph"
          [innerHTML]="getTranslation5()"
        ></p>
      </div>
      <div class="gdpr-text" *ngIf="newGdprNotice">
        <p>
          <T
            str="The declaration of consent can be revoked or changed at any time for the future and without giving reasons. Simply send us a message (e.g. with the e-mail you have stored with us)."
            key="customerPortal.kc.communication.gdpr.bottom-notice1"
            tags="kc-forms, 3.1"
          ></T>
        </p>
        <p>
          <T
            str="Your personal data will be treated confidentially in accordance with data protection regulations. A profile is created for the purposes mentioned."
            key="customerPortal.kc.communication.gdpr.bottom-notice2"
            tags="kc-forms, 3.1"
          ></T>
        </p>
        <!-- prettier-ignore -->
        <p
          [innerHTML]="getTranslation5()"
        ></p>
      </div>
    </div>
  </div>

  <div class="consents" *ngIf="country === 'ch'">
    <div class="grid gap-4 text-mat-ef-revolution-primary-500">
      <h2 class="font-canelablack text-4xl md:text-5xl">
        {{ 'data-protection' | sharedTranslate }}
      </h2>
      <div class="subtitle">
        {{ 'data-protection' | sharedTranslate }}
      </div>
      <!-- prettier-ignore -->
      <div>
        <p [innerHTML]="getTranslation6()"></p>
      </div>

      <form
        #consentsForm
        [action]="viewData.registrationAction"
        method="POST"
        [formGroup]="form"
      >
        <input type="hidden" name="step" value="gdpr" />
        <input
          *ngFor="let selectedChannel of selectedChannels"
          type="hidden"
          name="setConsents"
          [value]="selectedChannel"
        />
      </form>

      <div class="consent-button">
        <button
          mat-button
          mat-raised-button
          color="secondary"
          class="revolution w-full md:w-1/2 button-spinner"
          (click)="submit()"
          [disabled]="submitting"
        >
          <customer-portal-ef-spinner
            [color]="'mat-ef-revolution-grey-two-500'"
            [opacity]="0.7"
            [diameter]="16"
            *ngIf="submitting"
          >
          </customer-portal-ef-spinner>
          {{ 'next' | sharedTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>
